var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'p-error': _vm.refreshError || _vm.response.refreshError }},[_c('i',{staticClass:"far fa-fw fa-clock"}),_vm._v(" "+_vm._s(_vm._f("datetime")(`${_vm.refreshTime || _vm.response.refreshTime || Date.now()}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }